import MenuVariaveisSalesbox from "../MenuVariaveisSalesbox";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PalavraChaveFinanceira from "../PalavraChaveFinanceira";
import PesquisaArtigo from "../PesquisaArtigo";

export default function VariaveisFinanceiras() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <a href="/variaveis-salesbox">Variáveis Sales Box</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Variáveis financeiras
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuVariaveisSalesbox />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Variáveis financeiras</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Variáveis Sales Box</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Entenda nossas variáveis
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Compreender e monitorar variáveis financeiras é essencial para
                  tomada de decisões sólidas de acordo com o objetivo de negócio
                  ou estratégia de marketing, por exemplo. Seja gerenciando um
                  negócio ou pensando em uma estratégia de marketing
                  direcionado, a análise cuidadosa dessas variáveis pode
                  fornecer insights valiosos e orientação para o sucesso do seu
                  negócio.
                </p>

                <p>
                  Na
                  <a href="https://salesbox.com.br/" target="blank">
                    <a className="nav-item"> Sales Box</a>
                  </a>
                  , essas variáveis podem se utilizadas tanto na
                  <a
                    href="/como-criar-uma-segmentacao-de-clientes"
                    target="blank"
                  >
                    <a className="nav-item"> Segmentação de Clientes </a>
                  </a>
                  como na criação de um
                  <a href="/como-criar-um-publico-potencial" target="blank">
                    <a className="nav-item"> Público Potencial</a>
                  </a>
                  .
                </p>

                <p>
                  Importante ressaltar que, para as variáveis de escala númerica
                  utilizamos a progressão gradual, ou seja, à medida que nos
                  movemos de 1 para 100 ou de 1 para 1000, há uma tendência
                  geral de aumento na positividade ou veracidade dos números.
                </p>

                <p>
                  <h3 id="score">Score de Crédito</h3>
                </p>

                <p>Veja como utilizar esse dado tão importante.</p>

                <p>
                  <a id="scorecredito" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Score de crédito:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com probabilidade de adimplência baseada em
                  variáveis psicométricas (comportamentais) na concessão de
                  crédito.
                </p>

                <p>Escala: Número de 1 a 1000.</p>

                <figure>
                  <img src="img/score-publico-potencial.png" alt="integracao" />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <h3 id="risco">Risco Financeiro</h3>
                </p>

                <p>Veja como utilizar esse dado tão importante.</p>

                <p>
                  <a id="riscofinanceiro" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Risco financeiro:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com probabilidade de risco financeiro baseada em
                  variáveis psicométricas (comportamentais) na concessão de
                  crédito.
                </p>

                <p>Escala: "Alto", "Médio", "Baixo", "Baixíssimo".</p>

                <figure>
                  <img
                    src="img/risco-financeiro-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <a>
                <MenuInicioRapido />
              </a>
              <br></br>
              <br></br>
              <small>
                <PalavraChaveFinanceira />
              </small>
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
